namespace $.$$ {
	export class $exso_sheets_plans_class extends $.$exso_sheets_plans_class {
		@$mol_mem_key
		parse(data: Record<keyof $exso_sheets_plan, string>) {
			return {
				date: new this.$.$mol_time_moment(new Date(data.date)),
				place: data.place,
				burnt: parseFloat(data.burnt),
				blast: parseFloat(data.blast),
				date_str: data.date,
			} satisfies $exso_sheets_plan
		}
	}
	export const $exso_sheets_plans = new $exso_sheets_plans_class() as any as $exso_sheets<$exso_sheets_plan>
}
